// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgSmileIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2M8.652 13a.65.65 0 0 0-.652.652V14a4 4 0 0 0 8 0v-.348a.65.65 0 0 0-.652-.652zM9 9a1 1 0 1 0 0 2 1 1 0 0 0 0-2m6 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
      clipRule="evenodd"
    />
  </g>
);
export default SvgSmileIcon;
SvgSmileIcon.displayName = 'SvgSmileIcon';
